export const environment = {
  production: true,
  buildId: '3995282680324241',
  configFile: 'config.json',
};
